export default "__VITE_ASSET__0b1d855a__"